var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 90,
    viewBox: "0 0 115 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 70L53.8038 20.4427C54.462 19.8524 55.4593 19.8524 56.1177 20.4427L73.1995 44.8719V32.7057C73.1995 31.7484 73.9756 30.9725 74.9326 30.9725H86.4824C87.4394 30.9725 88.2155 31.7484 88.2155 32.7057V58.3355L101.225 70",
    stroke: "#FF0000",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFace);
export default __webpack_public_path__ + "static/media/bigFace.8241842bae49b246c4c4cf6f6f123e8b.svg";
export { ForwardRef as ReactComponent };